import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const TEAM_FRAGMENT = gqlTagGira`
    fragment jiraBusinessTeamFieldFragment on JiraTeamViewField {
        fieldId
        selectedTeam {
            jiraSuppliedName
            jiraSuppliedTeamId
        }
    } 
`;
